import { render } from "./ContentToDownload.vue?vue&type=template&id=214e8482"
import script from "./ContentToDownload.vue?vue&type=script&lang=js"
export * from "./ContentToDownload.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__